import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common.json";
import trCommon from "./locales/tr/common.json";

/** Same key as TopBar — keep app language in sync before React mounts */
const LANG_STORAGE_KEY = "rabo_i18n_language";

function getStoredLanguage() {
  try {
    const saved = localStorage.getItem(LANG_STORAGE_KEY);
    if (saved === "en" || saved === "tr") return saved;
  } catch {
    /* ignore */
  }
  return "tr";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    tr: { common: trCommon },
  },
  lng: getStoredLanguage(),
  fallbackLng: "en",
  supportedLngs: ["en", "tr"],
  defaultNS: "common",
  ns: ["common"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
